import axios from "axios";

export const getData = (tableName: string) => {  
    return axios.get(`/data/${tableName}`);
  };
  